export class LinkTokenRequest{
    public userId!:string;
    public userEmail!:string;
}